"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Utility_1 = require("../Utility");
var Checkbox = function (props) {
    var _a = (0, Utility_1.handleUtility)(props), children = _a.children, onChange = _a.onChange, border = _a.border, className = _a.className, inputRef = _a.inputRef, rest = __rest(_a, ["children", "onChange", "border", "className", "inputRef"]);
    var classes = (0, classnames_1.default)('t2-checkbox', {
        't2-border': border,
    }, className);
    var handleClick = function (e) {
        if (!props.disabled && onChange) {
            onChange(!props.checked, e);
        }
    };
    return (react_1.default.createElement("div", { role: "checkbox", className: classes, onClick: handleClick },
        react_1.default.createElement("input", __assign({ ref: inputRef, type: "checkbox", onChange: function () { return null; } }, rest)),
        react_1.default.createElement("label", null, children)));
};
exports.default = Checkbox;
